const amountWithCommas = (x = "") => {
  var parts = x?.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  return parts.join(".");
  // return x;
}

export default amountWithCommas;